import { captureException } from "@sentry/vue";

import type { VideoCallRatingQuery } from "@/Modules/Models/Api/VideoCalls";

import { sendRating } from "@/Services/TherapyApi/VideoCalls";

import { danger } from "@/Utils/Debug";

const SendVideoCallRating = async (roomId: string, query: VideoCallRatingQuery): Promise<boolean> => {
  try {
    await sendRating(roomId, query);

    return true;
  } catch (e) {
    danger(e);
    captureException(e);

    return false;
  }
};

export default SendVideoCallRating;
